import API_BASE_URL from "../../../../../Constants";

export const fetchPaymentTerms = async () => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/paymentterms/paymentterms`,
    {
      method: "GET",
      credentials: "include",
    }
  );
  const paymentTerms = await response.json();
  if (!response.ok) throw new Error(paymentTerms.message);

  return paymentTerms;
};

export const fetchTaxDetails = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/taxdetails/get-all`, {
    method: "GET",
    credentials: "include",
  });
  const taxDetails = await response.json();
  if (!response.ok) throw new Error(taxDetails.message);

  return taxDetails;
};

export const fetchSalesPersons = async () => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/salesperson/salespersons`,
    {
      method: "GET",
      credentials: "include",
    }
  );
  const salesPersons = await response.json();
  if (!response.ok) throw new Error(salesPersons.message);

  return salesPersons;
};
